"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleWidget = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles2 = _interopRequireWildcard(require("./styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TitleWidget = function TitleWidget(props) {
  var classes = (0, _styles2.default)();
  var theme = (0, _styles.useTheme)();
  var showMobile = (0, _useMediaQuery.default)(theme.breakpoints.down(_styles2.widgetMobileBreakPoint));
  var hidden = props.hidden,
      className = props.className,
      hide = props.hide,
      text = props.text,
      nonUsableWidth = props.nonUsableWidth;

  var computeMaxUsableWidth = function computeMaxUsableWidth() {
    var headerPaddingWidth = '48px';
    var localDividerWidth = '25px';
    var screenWidth = '100vw';
    return "calc(".concat(screenWidth, " - ").concat(headerPaddingWidth, " - ").concat(localDividerWidth, " - ").concat(nonUsableWidth, "px)");
  };

  if (hide) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_Hidden.default, hidden, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.container, className)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    style: showMobile ? {} : {
      maxWidth: computeMaxUsableWidth()
    },
    className: (0, _classnames.default)(showMobile ? classes.title : classes.titleOverflow),
    variant: showMobile ? 'body1' : 'h6'
  }, text)));
};

exports.TitleWidget = TitleWidget;
TitleWidget.propTypes = {
  /** text usado para customizar o nome do curso */
  text: _propTypes.default.string,

  /**
   * Valor usado para controlar a área de crescimento de texto e aplicação do ellipsis
   *
   * deve compreender a soma das larguras dos outros widgets e seus paddings e marging, para um correto funcionamento,
   *
   * ### Exemplo
   *
   * Considere que temos um logo de 140px de e um buttonicon de 60px de largura e a TitleWidget
   *
   * ```js
   *  // onde 200 é a soma das largura dos widgets, 140 + 60
   *  <TitleWidget text={textValue} nonUsableWidth={200} />
   * ```
   *
   * ### Detalhes do Cálculo da area usada pelo Texto do Widget
   * `larg` - `pad` - `divider` - `nonUsableWidth`
   *
   * onde:
   * * `larg` -> largutal total da tela
   * * `pad` -> padding do header
   * * `divider` -> largura do separador do titlewidget
   * * `nonUsableWidth` -> largura da prop fornecida que deve ser a soma da largura dos outros widgets
   */
  nonUsableWidth: _propTypes.default.number,

  /** Flag de curto-circuito para esconder o widget */
  hide: _propTypes.default.bool,

  /**
   * Propriedades para controlar quando esconder um objeto usa a mesma api do Componente do MUI Hidden
   * {@link https://v4.mui.com/components/hidden/#hidden [Detalhes]}
   */
  hidden: _propTypes.default.shape({
    lgDown: _propTypes.default.bool,
    lgUp: _propTypes.default.bool,
    mdDown: _propTypes.default.bool,
    mdUp: _propTypes.default.bool,
    only: _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])),
    smDown: _propTypes.default.bool,
    smUp: _propTypes.default.bool,
    xlDown: _propTypes.default.bool,
    xlUp: _propTypes.default.bool,
    xsDown: _propTypes.default.bool,
    xsUp: _propTypes.default.bool
  }),

  /** className usado para customizar o componente */
  className: _propTypes.default.string
};
TitleWidget.defaultProps = {
  nonUsableWidth: 0,
  hide: false,
  hidden: {
    lgDown: false,
    lgUp: false,
    mdDown: false,
    mdUp: false,
    only: null,
    smDown: false,
    smUp: false,
    xlDown: false,
    xlUp: false,
    xsDown: false,
    xsUp: false
  },
  className: '',
  text: ''
};